import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);





function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/login');
  }
}
  const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/login.vue'),
    beforeEnter: loggedInRedirectDashboard,
  },
  {
    path: '/registrasi',
    name: 'registrasi',
    component: () => import('../views/auth/registrasi.vue'),
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: isLoggedIn,
  },
 
  {
    path: '/menuList',
    name: 'menuList',
    component: () => import('../views/dataMaster/menuList.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/klpUsers',
    name: 'klpUsers',
    component: () => import('../views/dataMaster/klpUsers.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/masterKategoriPenolakan',
    name: 'masterKategoriPenolakan',
    component: () => import('../views/dataMaster/kategoriPenolakan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/masterOpdTerlapor',
    name: 'masterOpdTerlapor',
    component: () => import('../views/dataMaster/opdTerlapor.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/userMasyarakat',
    name: 'userMasyarakat',
    component: () => import('../views/dataMaster/userMasyarakat.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/pengaduan',
    name: 'pengaduan',
    component: () => import('../views/pengaduan/pengaduan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/telaah',
    name: 'telaah',
    component: () => import('../views/telaah/telaah.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/tindaklanjut',
    name: 'tindaklanjut',
    component: () => import('../views/telaah/tindaklanjut.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('../views/feedback/feedback.vue'),
    beforeEnter: isLoggedIn,
  },



]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
